import {
	FormSubmitResponse,
	IFormSubmitResponse
} from "./Models/FormSubmitResponse";
// tslint:disable-next-line: no-unnecessary-class
export class SignatureDropService {
	public static async sendForm(
		endpoint: string,
		payload: {
			AddressId: string;
			AddressUnit?: string | null;
			productType: string;
			TShirtSize?: string | null;
		}
	): Promise<IFormSubmitResponse | undefined> {
		try {
			const promise = $.ajax({
				contentType: "application/json",
				data: JSON.stringify(payload),
				type: "POST",
				url: endpoint
			});
			const result = await Promise.resolve(promise);

			return new FormSubmitResponse(result);
		} catch (err) {
			console.warn(err);
		}
	}
}
